<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-10-31 16:18:05
 * @LastEditTime: 2024-08-22 08:52:54
 * @LastEditors: xz
-->
<template>
  <div id="container" class="management">
    <div class="left">
      <div class="left-header">
        <img
          src="../../../static/img/report/plan.png"
          fit="fill"
          style="
            height: 80px;
            width: 80px;
            margin-bottom: 20px;
            cursor: pointer;
          "
          @click="toTemplate"
        />
        <div class="header-content">
          <div class="title">
            <span class="title-text" @click="toTemplate">{{
              templateName
            }}</span>
            -方案列表
          </div>
          <div class="search-box">
            <el-input
              v-model="searchText"
              style="width: 50%"
              placeholder="通过文件名搜索"
              size="small"
            >
              <template #append>
                <el-button
                  class="button-search"
                  icon="el-icon-search"
                  @click="searchTree"
                  size="small"
                />
              </template>
            </el-input>
            <el-popover placement="bottom" :width="300" trigger="click">
              <template #reference>
                <el-button
                  class="button-search"
                  type="primary"
                  icon="el-icon-setting"
                  size="small"
                  @click="searchTree"
                />
              </template>
              <el-checkbox v-model="checkList.createName" label="创建人" />
              <el-checkbox v-model="checkList.creatTime" label="创建时间" />
              <!-- <el-checkbox v-model="checkList.fileSize" label="文件大小" /> -->
            </el-popover>
          </div>
        </div>
      </div>
      <div class="table-box">
        <el-table
          ref="tableRef"
          :data="groupData"
          height="82vh"
          row-key="id"
          header-align="center"
          @row-click="checkRow"
        >
          <el-table-column
            label="文件名"
            :show-overflow-tooltip="true"
            min-width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.c_name }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="checkList.createName"
            label="创建人"
            align="center"
            width="90"
          >
            <template #default="scope">
              <span>{{ scope.row.c_who }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="checkList.creatTime"
            label="创建时间"
            align="center"
            min-width="120"
          >
            <template #default="scope">
              <span>{{ scope.row.c_when }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="140">
            <template #default="scope">
              <el-tooltip content="文件预览" placement="top">
                <!-- <el-button type="primary" size="small" icon="el-icon-view" @click="checkRow(scope.row)"></el-button> -->
                <i
                  class="el-icon-view"
                  @click.stop="checkRow(scope.row)"
                  style="font-size: 18px; color: #409eff; margin-right: 5px"
                ></i>
              </el-tooltip>
              <el-tooltip content="下载" placement="top">
                <!-- <el-button type="warning" size="small" icon="el-icon-download" @click="downFile(scope.row)"></el-button> -->
                <i
                  class="el-icon-download"
                  @click.stop="downFile(scope.row)"
                  style="font-size: 18px; color: #e6a23c; margin-right: 5px"
                ></i>
              </el-tooltip>
              <el-tooltip content="编辑" placement="top">
                <i
                  class="el-icon-edit"
                  @click.stop="goToEdit(scope.row)"
                  style="font-size: 18px; color: #67c23a; margin-right: 5px"
                ></i>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <i
                  class="el-icon-delete"
                  @click.stop="deleteShowFile(scope.row)"
                  style="font-size: 18px; color: #f56c6c; margin-right: 5px"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="right">
      <div class="file-box">
        <div style="font-size: 20px; color: #000; margin-bottom: 2px">
          {{ title }}
        </div>
        <div v-if="iframeUrl == ''">
          <div></div>
        </div>
        <iframe
          v-else
          :src="iframeUrl"
          frameborder="0"
          style="width: 100%; height: 100%"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { findAllType, download } from "@/api/file";
import templateApi from "@/api/report";
import { TUP, fileUrl, KKFILEURL } from "../../../utils/baseUrl";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      title: "",
      fileItemList: [],
      iframeUrl: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // url: PATH_URL + "file/fielpdf",
      tableData: [],
      groupData: [],
      fileUrl: "",
      file: {
        c_name: "",
      },
      searchText: "",
      templateId: 0,
      templateName: "",
      tableTreeRefreshTool: {},
      checkList: { fileSize: false, createName: false, creatTime: false },
    };
  },
  mounted() {
    // this.init();
    this.templateId = this.$route.params.id;
    this.templateName = this.$route.params.name;
    this.getFile();
  },
  methods: {
    getFile() {
      templateApi
        .getPlansByTemplate({ c_template: this.templateId })
        .then((res) => {
          // console.log(res, "res");
          if (res.data.code == 200) {
            this.groupData = res.data.data;
          }
        });
    },
    toTemplate() {
      this.$router.push("/ReportNew");
    },
    searchTree() {
      if (this.searchText == null || this.searchText == "") {
        this.getFile();
      } else {
        searchDocuments({ searchText: this.searchText, projectId: 0 }).then(
          (res) => {
            // console.log(res, "res");
            const data = res.data.data;
            this.groupData = data;
          }
        );
      }
    },
    //删除文件
    deleteShowFile(data) {
      this.$confirm("确定要删除这个文件", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delFileDirectory({ id: data.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("删除成功");
              this.reSetChildren(data.pid);
            } else {
              this.$message.success("删除失败");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    setSizeText(size) {
      if (size == null) {
        return "";
      } else if (size < 1024) {
        return size.toFixed(2) + "B";
      } else if (size < 1048576) {
        return (size / 1024).toFixed(2) + "KB";
      } else if (size < 1073741824) {
        return (size / 1048576).toFixed(2) + "MB";
      }
    },
    goToEdit(row) {
      this.$router.push({
        path: "/PlanBuild",
        query: { planId: row.id },
      });
    },
    checkRow(data) {
      var url = fileUrl + data.c_file_path; //要预览文件的访问地址
      //   var url = fileUrl + "pdfpath/1690979772085.jpg"; //要预览文件的访问地址
      //   console.log("url", url,KKFILEURL);
      this.title = data.fileName;
      this.iframeUrl =
        KKFILEURL +
        "/onlinePreview?url=" +
        encodeURIComponent(Base64.encode(url));
      // this.fileShow = true;
    },
    //下载文件
    downFile(data) {
      let params = {
        fileName: data.c_name,
        fileUrl: data.c_file_path,
      };
      download(params).then((res) => {
        let blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = data.fileName;
        link.click();
        URL.revokeObjectURL(url);
      });
    },
    setImage(data) {
      if (
        data.includes(".png") ||
        data.includes(".jpg") ||
        data.includes(".jepg")
      ) {
        return require("../../../static/file/tupian.png");
      } else if (data.includes(".docx") || data.includes(".doc")) {
        return require("../../../static/file/zhanbeizhishou-word.png");
      } else if (data.includes(".xlsx") || data.includes(".xls")) {
        return require("../../../static/file/t_excelwenjian.png");
      } else if (data.includes(".pdf")) {
        return require("../../../static/file/Pdf.png");
      } else if (data.includes(".ppt")) {
        return require("../../../static/file/PPT.png");
      } else if (data.includes(".mp4")) {
        return require("../../../static/file/mp4.png");
      } else if (data.includes(".txt")) {
        return require("../../../static/file/txt.png");
      } else if (data.includes(".json")) {
        return require("../../../static/file/JSON.png");
      } else if (data.includes(".caj")) {
        return require("../../../static/file/CAJ.png");
      } else if (data.includes(".flv")) {
        return require("../../../static/file/flv.png");
      } else if (data.includes(".mp3")) {
        return require("../../../static/file/MP.png");
      } else if (data.includes(".docx")) {
        return require("../../../static/file/docx.png");
      }
    },
  },
};
</script>

<style scoped>
.management {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: 100vh; direction: row;
    justify-
  overflow: hidden;

  ::-webkit-scrollbar {
    display: none;
  }

  /* .el-table {
      .cell{
          display:flex;
          justify-content: safe;
          align-items: center;
      }
    } */
}

.table-box {
  width: 98%;
  height: 100%;
}

.left {
  width: 38%;
  height: 98%;
}
.left-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  height: 90px;
  /* width: 100%; */
  padding: 10px 10px 0 10px;
  background-color: #f0f2f5;
  border-bottom: 1px solid #e4e4e4;
}
.header-content {
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 100%;
  height: 100%;
  padding-left: 1%;
}
.title-text {
  color: rgb(54, 121, 255);
  font-weight: bold;
  font-size: 22px;
  border-bottom: 1px solid rgb(0, 85, 255);
  cursor: pointer;
}
.title-text:hover {
  /* font-size: 24px; */
  color: rgba(26, 102, 255, 0.7);
  border-bottom: 2px solid rgb(0, 85, 255, 0.6);
}
.search-box {
  /* padding: 0 2%; */
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 0.25rem;
  margin-bottom: 1rem;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: 0.0125rem solid;
}

.header_left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header_back {
  display: flex;
  align-items: center;
  padding-right: 0.125rem;
  border-right: 0.025rem solid rgba(0, 128, 192, 0.5);
  cursor: pointer;
}

.header_page {
  padding-left: 0.125rem;
}

.header_content {
  display: flex;
}

.upload-demo {
  display: flex;
  margin-right: 0.125rem;
  border-bottom: rgba(237, 252, 75, 0.5) 0.0125rem solid;
}

.right {
  width: 62%;
  height: 98%;
  /* border-radius: 1rem; */
  padding: 1rem 0 0 1rem;
  /* border: 1px blue solid; */
  box-shadow: 0 0 3px rgb(46, 43, 43);
}

.file-box {
  width: 100%;
  height: 94%;
  padding-right: 2%;
}

.file_name {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 4%;
}

.fileNameSpan {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 0.25rem;
  line-height: 0.25rem;
}

.tubiao {
  width: 0.3125rem;
  height: 0.3125rem;
  margin-right: 0.0625rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Reports/planList.vue